'use es6';

import { useEffect, useState } from 'react';
import { Form } from 'foundations-components/transitional/components/Form';
import { useMutation } from 'data-fetching-client';
import ChannelSelector from 'share-with-third-party-component-lib/components/selectors/ChannelSelector';
import UserSelector from 'share-with-third-party-component-lib/components/selectors/UserSelector';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import isEmpty from 'transmute/isEmpty';
import { UPDATE_TO_FETCH_SLACK_NAME_FIELD } from '../../../data/requests/thirdPartyApps';
import { SHARE_THIRD_PARTY_APP_RECIPIENT_NAME } from '../../../data/requests/thirdPartyApps';
import { THIRD_PARTY_APP_CHANNEL } from '../shareTypes';
import { useControlsContext } from '../context';
import ShareCadenceOptions from '../inputFields/ShareCadenceOptions';
import ShareToSlackChannelOrUserRadioButton from '../inputFields/ShareToSlackChannelOrUserOptions';
import ShareMessageTextInput from '../inputFields/ShareMessageTextInput';
import ShareScheduling from '../inputFields/ShareScheduling';
import ShareScheduledNicknameTextInput from '../inputFields/ShareScheduledNicknameTextInput';

// TODO: Add resetSelectedReports when sharing with Dashboard
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShareToSlackAssetDialog = () => {
  const {
    thirdPartyApp,
    thirdPartyAppShareOptionType,
    thirdPartyAppShareOptionSelection,
    setThirdPartyAppShareOptionSelection,
    isEditingScheduledEmail,
    isRecurringShareAsset
  } = useControlsContext();
  const thirdPartyAppId = thirdPartyApp === null || thirdPartyApp === void 0 ? void 0 : thirdPartyApp.id;
  const [isLoadingDefaultName, setIsLoadingDefaultName] = useState();
  const [fetchSlackNameMutation, {
    loading
  }] = useMutation(UPDATE_TO_FETCH_SLACK_NAME_FIELD, {
    onCompleted: response => {
      setThirdPartyAppShareOptionSelection(Object.assign({
        name: response[SHARE_THIRD_PARTY_APP_RECIPIENT_NAME].name
      }, thirdPartyAppShareOptionSelection));
      setIsLoadingDefaultName(false);
    }
  });
  useEffect(() => {
    if (thirdPartyAppShareOptionSelection && thirdPartyAppShareOptionSelection.name) return;
    if (isEmpty(thirdPartyAppShareOptionSelection) || !isEditingScheduledEmail) return;
    setIsLoadingDefaultName(true);
    fetchSlackNameMutation({
      variables: thirdPartyAppShareOptionSelection
    });
  }, [fetchSlackNameMutation, isEditingScheduledEmail, thirdPartyAppShareOptionSelection]);
  const isLoading = loading || isLoadingDefaultName;
  return /*#__PURE__*/_jsxs(Form, {
    autoComplete: "off",
    inlineSize: "100%",
    children: [!isEditingScheduledEmail && /*#__PURE__*/_jsx(ShareCadenceOptions, {}), isRecurringShareAsset && /*#__PURE__*/_jsx(ShareScheduledNicknameTextInput, {}), /*#__PURE__*/_jsx(ShareToSlackChannelOrUserRadioButton, {}), isLoading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered"
    }) : thirdPartyAppShareOptionType === THIRD_PARTY_APP_CHANNEL ? /*#__PURE__*/_jsx(ChannelSelector, {
      onChange: e => setThirdPartyAppShareOptionSelection(e),
      appId: thirdPartyAppId,
      defaultValue: thirdPartyAppShareOptionSelection
    }) : /*#__PURE__*/_jsx(UserSelector, {
      onChange: e => setThirdPartyAppShareOptionSelection(e),
      appId: thirdPartyAppId,
      defaultValue: thirdPartyAppShareOptionSelection
    }), /*#__PURE__*/_jsx(ShareMessageTextInput, {}), (isRecurringShareAsset || isEditingScheduledEmail) && /*#__PURE__*/_jsx(ShareScheduling, {})]
  });
};
export default ShareToSlackAssetDialog;